import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Sparkles } from 'lucide-react'
import { PageHeader, displayTitleClass } from '#/components/page-header'
import { PageContainer } from '#/components/page-container'

export const Route = createFileRoute('/_authed/accounts/$accountId/whats-new')({
  component: WhatsNewPage,
})

const RELEASES = [
  { key: 'askAnnwn', items: ['one', 'two', 'three'] },
  { key: 'cdpDrafting', items: ['one', 'two', 'three'] },
] as const

function WhatsNewPage() {
  const { t } = useTranslation()

  return (
    <PageContainer width="reading" className="gap-10">
      <PageHeader
        eyebrow={t('nav.whatsNew')}
        eyebrowIcon={Sparkles}
        title={t('whatsNew.title')}
      />

      {RELEASES.map((release) => (
        <section key={release.key} className="flex flex-col gap-3">
          <p className="text-label-md text-muted-foreground">
            {t(`whatsNew.releases.${release.key}.date`)}
          </p>
          <h2 className={displayTitleClass('sm')}>
            {t(`whatsNew.releases.${release.key}.title`)}
          </h2>
          <ul className="flex flex-col gap-2 text-sm text-muted-foreground">
            {release.items.map((item) => (
              <li key={item} className="flex gap-2">
                <span aria-hidden="true" className="select-none">
                  •
                </span>
                <span>
                  {t(`whatsNew.releases.${release.key}.items.${item}`)}
                </span>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </PageContainer>
  )
}
